import { render, staticRenderFns } from "./selectFamily.vue?vue&type=template&id=59455da2&"
import script from "./selectFamily.vue?vue&type=script&lang=ts&"
export * from "./selectFamily.vue?vue&type=script&lang=ts&"
import style0 from "./selectFamily.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports